import React, { useState } from "react";
import { Grid, Card, CardContent, Collapse } from "@material-ui/core/";
import SummaryValue from "./SummaryValue/SummaryValue";
import SummaryQuestion from "./SummaryQuestion/SummaryQuestion";
import SummaryHeader from "./SummaryHeader";
import SummaryAnchor from "./SummaryAnchor/SummaryAnchor";
import gridStyles from "../../../theme/gridStyles";
import { forIn } from 'lodash';

export default function SummaryContent(props) {
    const { answers, title, sections } = props;
    const [questionsExpanded, setQuestionsExpanded] = useState(true);
    const handleExpandQuestionsClick = () => {
        setQuestionsExpanded(!questionsExpanded);
    };

    const getAnchors = (answerValues, sizes) => {
        return answerValues.map((answer, i) => {
            return(
                <SummaryAnchor
                key={`summary-anchor-${i}`}
                url={answer.path}
                title={answer.name}
                fileSize={answer.size}
                sizes={sizes}
                type={answer.type}
            />
            )
        });
    };

    const displayAnswers = (answers) => {
        return answers.filter(answer => answer.textValue || answer.value).map((answer) => {
            const sizes = answer.group === "eligibility"
                ? gridStyles.eligibilitySummarySizes
                : answer.group === "payee"
                ? gridStyles.payeeSummarySizes
                : gridStyles.validateSummarySizes;

            if (answer.showOnSummary === true || answer.showOnSummary === undefined) {
                return answer.value === true ? (
                    <SummaryQuestion
                        key={answer.id}
                        label={answer.summaryLabel ? answer.summaryLabel : answer.label}
                    />
                ) : answer.type !== "file" ? (
                    <SummaryValue
                        sizes={sizes}
                        key={answer.name}
                        label={answer.summaryLabel ? answer.summaryLabel : answer.label}
                        group={answer.group}
                        required={answer.required}
                        value={answer.textValue || answer.value}
                    />
                ) : (
                    getAnchors(answer.value, gridStyles.eligibilitySummarySizes)
                );
            } else {
                return null;
            }
        })
    }

    const displaySections = (sections) => {
        if (!sections) return null;
        let sectionElement = [];
        forIn(sections, function(answers) {
            sectionElement.push(
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Card variant="outlined">
                        <CardContent>
                            <Grid container spacing={2}>
                                {displayAnswers(answers)}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            )
        });
        return sectionElement;
    }

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card>
                <SummaryHeader
                    title={title}
                    handleFunction={handleExpandQuestionsClick}
                    valueExpanded={questionsExpanded}
                ></SummaryHeader>
                <Collapse in={questionsExpanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Grid container spacing={2}>
                            {displayAnswers(answers)}
                            {displaySections(sections)}
                        </Grid>
                    </CardContent>
                </Collapse>
            </Card>
        </Grid>
    );
}
